export default __webpack_public_path__ + "static/media/shocks-equation.3175f829.png";